import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, retry, throwError, timer } from 'rxjs';

export const retryInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    retry({
      count: 3,
      delay: (error) => {
        return error.status === 504 ? timer(1000) : throwError(() => error);
      },
    }),
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
};
